import router from '../router'
import store from '../store'
import createRoutes from './createRoutes'

//前置路由守卫
router.beforeEach(async (to, from, next) => {
	// console.log('路由守卫');
	// console.log(to, from);
	if(to.path === '/'){
		router.replace({path:'/home'});
	}

	// router.addRoutes([
	// 	{
	// 		path: '/icon',
	// 		name: 'icon',
	// 		component: () => import('../components/swipeIcon.vue')
	// 	}
	// ])

	next();
})

//后置路由守卫
router.afterEach(() => {
})


// WEBPACK FOOTER //
// ./src/utils/permission.js